export default class WellRecord {
  constructor() {
    this.numWells = 0;
    this.wellScreens = [];
    this.latestElevation = null;
  }

  update(newWellElevation) {
    this.wellScreens.push(newWellElevation);
    this.wellScreens.sort(function(a, b) {
      return a > b;
    });
    this.latestElevation = newWellElevation;
    this.numWells = this.numWells + 1;
  }

  containsWellScreen(elevation) {
    for (let screen in this.wellScreens) {
      if (this.wellScreens[screen] === elevation) {
        return true;
      }
    }
    return false;
  }
}
